export const CLIENTS_ROUTER_NAMES = {
  ITEMS: "clients-items",
  EDIT: "clients-edit",
  CREATE: "clients-create",
};

export const CLIENTS_ROUTER_PATHS = {
  ITEMS: "/clients",
  EDIT: "/clients/:id",
  CREATE: "/clients/create",
};
